<template>
  <span v-if="showPricing">{{displayPrice}}</span>
  <span v-else>
    <slot>
      <base-snippet name="hidden_price_text"></base-snippet>
    </slot>
  </span>
</template>

<script>
  import {priceStr} from "vue-src/utils"
  import {showPricing} from "vue-src/utils/scopeHelpers"

  export default {
    name: "base-price",
    props:{
      price:{
        type: [Number,String],
        required: true,
      }
    },
    computed:{
      showPricing,
      displayPrice(){
        return priceStr(this.price)
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-price.vue